import { Box, Grid2 as Grid, Stack, Typography, useTheme } from "@mui/material";
import { ComponentProps } from "react";
import { useRiskBannerHeight } from "../../hooks/ace/use-risk-banner-height";

export const OnboardingLayout = (props: ComponentProps<"div">) => {
  const { children } = props;
  const theme = useTheme();
  const riskBannerHeight = useRiskBannerHeight();

  return (
    <Stack
      style={{
        display: "flex",
        maxWidth: "100%",
        marginTop: riskBannerHeight,
      }}
    >
      <Box
        component={Grid}
        container
        sx={{
          justifyContent: "end",
        }}
        height={{ xs: `calc(100vh - ${riskBannerHeight}px)` }}
      >
        <Box
          component={Grid}
          display={{ xs: "none", md: "block" }}
          sx={{ flex: "1" }}
          bgcolor={theme.palette.neutral[900]}
        >
          <Stack
            height="100%"
            justifyContent="center"
            alignItems="center"
            position={"relative"}
          >
            <img
              src="/assets/glow.svg"
              alt="glow"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "-40%",
                zIndex: 1,
              }}
            />
            <img
              src="/assets/wings.svg"
              alt="wings"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                zIndex: 0,
              }}
            />
            <img
              src="/assets/archax-logo.svg"
              alt="archax-logo"
              style={{ zIndex: 10 }}
              data-cy="archax-logo"
            />
            <Typography pt={3} variant="h4" data-cy="archax-tagline">
              Exchange, Custodian, Broker
            </Typography>
          </Stack>
        </Box>
        <Stack
          width={{ xs: "100%", md: "50%", lg: 550 }}
          sx={{
            height: "100%",
            overflow: "auto",
            backgroundColor: theme.palette.background.default,
            zIndex: 10,
            pb: 6,
          }}
        >
          <Stack
            justifyContent={{ xs: "initial", md: "center" }}
            minHeight={{ md: "94%" }}
            px={{ md: 8, xs: 3 }}
            spacing={3}
            mt={{ xs: 5 }}
          >
            <Box display={{ md: "none", xs: "block" }}>
              <img
                data-cy="login-archax-logo"
                src="/assets/archax-web-logo.svg"
                alt="archax-logo"
              />
            </Box>
            {children}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default OnboardingLayout;
